import { useCallback } from 'react'
import { Button, Card, Title, Tooltip } from '@panwds/react-ui'
import './splashScreen.scss'
import { setUserFlow } from '../../../common/reducers/actions/LicenseReducer.actions'
import SplashFooter from './SplashFooter'
import PaloAltoNetworks from './PaloAltoNetworks'
import {
  BUTTON_MSP_AND_DISTRIBUTED_ENTERPRISE, BUTTON_NEED_HELP,
  BUTTON_SIMPLE_SINGLE_TENANT,
  LABEL_SELECT_ACTIVATION_FLOW, TOOLTIP_MT_BUTTON, TOOLTIP_ST_BUTTON, USER_FLOW_MULTI, USER_FLOW_SINGLE
} from '../constants/SubscriptionConstant'
import PropTypes from 'prop-types'

/**
 * This component handle the splash screen for when user dont have any tsg that time we have to show user
 * path to either go to Single Tenant workflow or Multi-Tenant workflow
 * Take need help to onboarding helper link
 * @type {(function())|*}
 */


const ActivationFlowFork = ({ handleFlowType, licenseDispatch }) => {
  const handleOnClick = useCallback(() => {
    window.open('https://docs.paloaltonetworks.com/common-services/subscription-and-tenant-management', '_blank')
  }, [])

  const onClickFlowType = useCallback(({ flowType }) => {
    licenseDispatch(setUserFlow(flowType))
    //sessionStorage.setItem('USER_FLOW', flowType)
    handleFlowType({ flowType })
  }, [handleFlowType, licenseDispatch])
  return (
    <div className='splashScreen'>
      <div className='splashMain tw-h-full tw-block tw-flex tw-flex-col tw-justify-center tw-items-center'>
        <Card style={{ width: '448px', height: '354px', padding: 32 }} >
          <div className={'tw-h-full tw-flex tw-flex-col tw-items-center'}>
            <PaloAltoNetworks />
            <div style={{ margin: '36px 0' }}>
              <Title level={2} size="sm">
                {LABEL_SELECT_ACTIVATION_FLOW}
              </Title>
            </div>
            <Tooltip label={TOOLTIP_ST_BUTTON}>
              <Button size="lg"
                appearance="primary"
                style={{ width: '100%', height: 40 }}
                onClick={() => onClickFlowType({ flowType: USER_FLOW_SINGLE })}
                addClassName={'tw-flex tw-justify-center'}>{BUTTON_SIMPLE_SINGLE_TENANT}</Button>
            </Tooltip>
            <Tooltip label={TOOLTIP_MT_BUTTON}>
              <Button size="lg"
                appearance="primary"
                onClick={() => onClickFlowType({ flowType: USER_FLOW_MULTI })}
                style={{ width: '100%', margin: '16px 0', height: 40 }}
                addClassName={'tw-flex tw-justify-center'}>{BUTTON_MSP_AND_DISTRIBUTED_ENTERPRISE}</Button>
            </Tooltip>
          </div>
        </Card>
        <Button appearance={'clear'} onClick={handleOnClick}>{BUTTON_NEED_HELP}</Button>
      </div>
      <div className='splashFooter tw-flex tw-flex-row'>
        <SplashFooter showLogo={true} showSignature={true}/>
      </div>
    </div>
  )
}

ActivationFlowFork.propTypes = {
  handleFlowType: PropTypes.func,
}

export default ActivationFlowFork
